export function zip<T, U>(valuesA:T[], valuesB:U[]):[T,U][] {
  return valuesA.map<[T,U]>((valueA, index) => [valueA, valuesB[index]]);
}



/** WEBPACK FOOTER **
 ** ./app/utils/iter-functions.ts
 **/